<template>
	<svg
		width="24px"
		height="16px"
		viewBox="0 0 24 16"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
	>
		<g
			id="Mentions"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Mentions---Start-Typing"
				transform="translate(-357.000000, -803.000000)"
				fill="#4F5053"
				fill-rule="nonzero"
			>
				<path
					d="M360.6,809.857143 C361.92375,809.857143 363,808.832143 363,807.571429 C363,806.310714 361.92375,805.285714 360.6,805.285714 C359.27625,805.285714 358.2,806.310714 358.2,807.571429 C358.2,808.832143 359.27625,809.857143 360.6,809.857143 Z M377.4,809.857143 C378.72375,809.857143 379.8,808.832143 379.8,807.571429 C379.8,806.310714 378.72375,805.285714 377.4,805.285714 C376.07625,805.285714 375,806.310714 375,807.571429 C375,808.832143 376.07625,809.857143 377.4,809.857143 Z M378.6,811 L376.2,811 C375.54,811 374.94375,811.253571 374.50875,811.664286 C376.02,812.453571 377.0925,813.878571 377.325,815.571429 L379.8,815.571429 C380.46375,815.571429 381,815.060714 381,814.428571 L381,813.285714 C381,812.025 379.92375,811 378.6,811 Z M369,811 C371.32125,811 373.2,809.210714 373.2,807 C373.2,804.789286 371.32125,803 369,803 C366.67875,803 364.8,804.789286 364.8,807 C364.8,809.210714 366.67875,811 369,811 Z M371.88,812.142857 L371.56875,812.142857 C370.78875,812.5 369.9225,812.714286 369,812.714286 C368.0775,812.714286 367.215,812.5 366.43125,812.142857 L366.12,812.142857 C363.735,812.142857 361.8,813.985714 361.8,816.257143 L361.8,817.285714 C361.8,818.232143 362.60625,819 363.6,819 L374.4,819 C375.39375,819 376.2,818.232143 376.2,817.285714 L376.2,816.257143 C376.2,813.985714 374.265,812.142857 371.88,812.142857 Z M363.49125,811.664286 C363.05625,811.253571 362.46,811 361.8,811 L359.4,811 C358.07625,811 357,812.025 357,813.285714 L357,814.428571 C357,815.060714 357.53625,815.571429 358.2,815.571429 L360.67125,815.571429 C360.9075,813.878571 361.98,812.453571 363.49125,811.664286 Z"
					id="Shape"
				/>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'EveryoneIcon',
}
</script>
